/**
 * Aspect — Admin Portal bootstrap
 */

import "../ui/glass-theme.css";
import "./portal.css";
import "./admin.css";
import { route, startRouter, navigate } from "./router.js";
import { getSession } from "./auth_store.js";
import { getLang, setLang } from "./i18n.js";
import { renderLogin } from "./views/login.js";
import { renderRegister } from "./views/register.js";
import { renderForgotPassword } from "./views/forgot_password.js";
import { renderResetPassword } from "./views/reset_password.js";
import { renderOverview } from "./views/overview.js";
import { renderSpaces } from "./views/spaces.js";
import { renderJobs } from "./views/jobs.js";
import { renderFiles } from "./views/files.js";
import { renderAnalytics } from "./views/analytics.js";
import { renderClients } from "./views/clients.js";
import { renderActivity } from "./views/activity.js";
import { renderTeam } from "./views/team.js";
import { renderBilling } from "./views/billing.js";
import { renderIntegrations } from "./views/integrations.js";
import { renderSettings } from "./views/settings.js";
import { renderAudit } from "./views/audit.js";
import { renderSupport } from "./views/support.js";
import { renderLanding } from "../landing/page.js";

const root = document.getElementById("portal-root");
if (!root) throw new Error("portal-root missing");

// Global EN ⇄ ქართული toggle: any [data-lang] button switches the language
// and re-renders the current route in place.
document.addEventListener("click", (e) => {
  const btn = e.target.closest("[data-lang]");
  if (!btn || btn.dataset.lang === getLang()) return;
  setLang(btn.dataset.lang);
  window.dispatchEvent(new Event("hashchange"));
});

function render(fn) {
  // Clean up document-level listeners installed by previous views
  root._menuDocClick && document.removeEventListener("click", root._menuDocClick);
  root._shellDocClick && document.removeEventListener("click", root._shellDocClick);
  root._shellKeydown && document.removeEventListener("keydown", root._shellKeydown);
  root._menuDocClick = null;
  root._shellDocClick = null;
  root._shellKeydown = null;
  fn(root);
}

route("/login", () => render(renderLogin));
route("/", () => render(renderLanding));
route("/register", () => render(renderRegister));
route("/forgot-password", () => render(renderForgotPassword));
route("/reset-password", () => render(renderResetPassword));

route("/dashboard", () => render(renderOverview));
route("/spaces", () => render(renderSpaces));
route("/jobs", () => render(renderJobs));
route("/files", () => render(renderFiles));
route("/analytics", () => render(renderAnalytics));
route("/clients", () => render(renderClients));
route("/activity", () => render(renderActivity));
route("/team", () => render(renderTeam));
route("/billing", () => render(renderBilling));
route("/integrations", () => render(renderIntegrations));
route("/settings", () => render(renderSettings));
route("/audit", () => render(renderAudit));
route("/support", () => render(renderSupport));

startRouter(() => {
  const session = getSession();
  if (session) navigate("/dashboard", true);
  else navigate("/", true);
});

// Default hash when opening portal.html with no hash
if (!window.location.hash) {
  const session = getSession();
  navigate(session ? "/dashboard" : "/", true);
}
